import { match } from 'ts-pattern';
import useUrlStep from 'hooks/ui/useUrlStep';

export enum CreationStep {
  CreateNotice = 'create',
  Summary = 'summary',
  Completion = 'complete',
}

export const useCreationStep = (dataIsValid?: boolean) => {
  const getValidStep = (rawStep: string | null) =>
    match(rawStep)
      .with(CreationStep.Completion, CreationStep.Summary, (step) =>
        dataIsValid ? step : CreationStep.CreateNotice,
      )
      .otherwise(() => CreationStep.CreateNotice);

  return useUrlStep(getValidStep);
};
